import { UrlTree } from '@angular/router';

import { firstValueFrom, Observable, Subject } from 'rxjs';

import { SummitDialogDirective } from './directives';
import { ISummitForm } from './models';

export class ComponentFunctions {
  public static async IsValidToUnloadAsync(component: ISummitForm): Promise<boolean> {
    const response = this.ValidToUnload(component);
    switch (typeof response) {
      case 'boolean':
        return response;
      case 'object': {
        const responseObservable = response as Observable<boolean>;
        return (await firstValueFrom(responseObservable)) ?? false;
      }
      default:
        console.error(`Unknown Type: ${typeof response}:`, response);
    }
    return true;
  }

  public static ValidToUnload(
    component: ISummitForm
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (component && component.hasUnSavedData && component.hasUnSavedData()) {
      const responseSubject = new Subject<boolean>();
      const sDialog = new SummitDialogDirective();
      sDialog.confirmAction(
        {
          data: {
            confirmType: 'delete',
            title: 'Unsaved Changes',
            name: 'Are you sure you want to leave?',
            action: 'Leave',
            cancel: 'Stay',
            question: 'You have unsaved changes. Your changes will be lost.'
          }
        },
        () => {
          //console.log('User confirmed to leave');
          responseSubject.next(true);
        },
        () => {
          //console.log('User wants to stay');
          responseSubject.next(false);
        }
      );
      return responseSubject.asObservable();
    }
    return true;
  }
}
